import React from 'react';
import { Field } from 'react-final-form';
import { string } from 'prop-types';
import classNames from 'classnames';

import { useIntl } from '../../util/reactIntl';
import { composeValidators, required as requiredValidator } from '../../util/validators';
import { getUTCDateString, isFutureListingDate, isValidListingDate } from '../../util/listingRules';

import css from './FieldFillDateInput.module.css';

const FillDateInputComponent = props => {
  const { input, meta, fieldId, label, placeholderText, className, maxDate } = props;

  const hasError = meta.touched && meta.error;
  const fieldClasses = classNames(css.root, className, {
    [css.inputError]: hasError,
  });

  return (
    <div className={fieldClasses}>
      {label ? <label htmlFor={fieldId}>{label}</label> : null}

      <input
        id={fieldId}
        type="date"
        value={input.value || ''}
        onChange={input.onChange}
        onBlur={input.onBlur}
        onFocus={input.onFocus}
        className={css.dateInput}
        placeholder={placeholderText}
        max={maxDate}
      />

      {hasError ? <span className={css.errorText}>{meta.error}</span> : null}
    </div>
  );
};

const FieldFillDateInput = ({ id = null, name = 'pub_fillDate', className = null }) => {
  const intl = useIntl();

  const fieldName = name || 'pub_fillDate';
  const fieldId = id || fieldName;

  const label = intl.formatMessage({ id: 'FieldFillDateInput.label' });
  const placeholderText = intl.formatMessage({ id: 'FieldFillDateInput.placeholder' });
  const requiredMessage = intl.formatMessage({ id: 'FieldFillDateInput.required' });
  const invalidMessage = intl.formatMessage({ id: 'FieldFillDateInput.invalid' });
  const futureMessage = intl.formatMessage({ id: 'FieldFillDateInput.future' });
  const maxDate = getUTCDateString();

  const validDate = value => (value && !isValidListingDate(value) ? invalidMessage : undefined);
  const notInFuture = value => (value && isFutureListingDate(value) ? futureMessage : undefined);

  return (
    <Field
      name={fieldName}
      validate={composeValidators(requiredValidator(requiredMessage), validDate, notInFuture)}
      render={({ input, meta }) => (
        <FillDateInputComponent
          input={input}
          meta={meta}
          fieldId={fieldId}
          label={label}
          placeholderText={placeholderText}
          className={className}
          maxDate={maxDate}
        />
      )}
    />
  );
};

FieldFillDateInput.propTypes = {
  id: string,
  name: string,
  className: string,
};

export default FieldFillDateInput;
